/*
  Bundle builder on phones: the fixed Juo drawer (tier bubbles, subscribe line,
  total + checkout) took about a third of the screen (256 px of 812). It now
  starts collapsed to one line — "N gekozen" with a thin progress line next to
  Juo's own tier text — with the subscribe line kept compact (Marcel 19-10, C6)
  and total + Afrekenen below. Expanding stays Juo's own chevron (.show-items),
  so Juo's internal open/closed state stays right; the visitor's choice is kept
  for the session. Desktop is untouched (Juo hides .show-items from 768 px).

  Juo markup (extension juo-subscriptions, measured 19-10): .box-builder__drawer
  > .header-wrapper (.tiers-description + button.show-items.active) +
  .progress-bar, .subscribe-box-wrapper, .box-summary. Every selector is
  guarded: if Juo renames something, this script does nothing.
*/
;(function () {
  var MQ = window.matchMedia('(max-width: 767px)');
  var KEY = 'hs-bab-lade';

  function lees() { try { return window.sessionStorage.getItem(KEY); } catch (e) { return null; } }
  function schrijf(v) { try { window.sessionStorage.setItem(KEY, v); } catch (e) {} }

  // Count = sum of Juo's own quantity fields (also right for split variants and > 11 products).
  function aantal() {
    var n = 0;
    document.querySelectorAll('.box-builder__products-list .product-qty-input').forEach(function (i) {
      n += parseInt(i.value, 10) || 0;
    });
    return n;
  }

  function juoKlaar(lade) {
    // Juo sets inline overflow:hidden on .progress-bar when it initialises; a click before that does nothing.
    var pb = lade.querySelector('.progress-bar');
    return pb && pb.style.overflow === 'hidden';
  }

  function init() {
    var lade = document.querySelector('.box-builder__drawer');
    var knop = lade && lade.querySelector('.show-items');
    var kop = lade && lade.querySelector('.header-wrapper');
    if (!lade || !knop || !kop) return true;
    if (!juoKlaar(lade)) return false;
    if (lade.querySelector('.hs-bab-mini')) return true;

    var maxEl = document.querySelector('[data-hs-bundel-max]');
    var max = maxEl ? parseInt(maxEl.getAttribute('data-hs-bundel-max'), 10) || 7 : 7;

    var mini = document.createElement('div');
    mini.className = 'hs-bab-mini';
    mini.innerHTML = '<span class="hs-bab-mini__aantal" aria-live="polite"></span>' +
                     '<span class="hs-bab-mini__lijn" aria-hidden="true"><span></span></span>';
    kop.insertBefore(mini, kop.firstChild);
    knop.setAttribute('aria-label', 'Toon je gekozen producten');

    function sync() {
      var open = knop.classList.contains('active');
      lade.classList.toggle('hs-bab-ingeklapt', MQ.matches && !open);
      knop.setAttribute('aria-expanded', String(open));
      var n = aantal();
      mini.querySelector('.hs-bab-mini__aantal').textContent = n + ' gekozen';
      mini.style.setProperty('--hs-bab-pct', Math.min(100, Math.round((n / max) * 100)) + '%');
    }

    // Collapsed by default on phones, unless the visitor opened it this session.
    if (MQ.matches && knop.classList.contains('active') && lees() !== 'open') knop.click();

    // Our listener is on the button, Juo's on document: Juo toggles after us, so read the state next tick.
    knop.addEventListener('click', function () {
      setTimeout(function () { schrijf(knop.classList.contains('active') ? 'open' : 'dicht'); sync(); }, 0);
    });
    document.addEventListener('juo-box:updated:state', function () { window.requestAnimationFrame(sync); });
    if (MQ.addEventListener) MQ.addEventListener('change', sync);
    sync();
    return true;
  }

  function start() {
    if (init()) return;
    var obs = new MutationObserver(function () { if (init()) obs.disconnect(); });
    obs.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
    setTimeout(function () { obs.disconnect(); }, 15000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
